import { connect } from 'react-redux';
import { compose, pureWithState } from '../../../../src/web/utils/react';
import { imageWidget, editor } from '../../../../src/web/components/widgets/decorators';
import { NAME, ID } from './properties';
import ImageGrid from './ImageGrid';
import { getCompanyId } from '../../../../src/web/store/modules/company';
import { getCurrentFile, clear } from '../../../../src/web/store/modules/assets';
import Editor from '../../../../modules/react/editors/ImageWidget';

export default compose(
  connect(
    state => ({
      companyId: getCompanyId(state),
      uploadedFile: getCurrentFile(state),
      limit: 4,
      widgetName: 'Image Grid',
    }), { clearUpload: clear },
  ),
  editor(Editor),
  pureWithState(),
  imageWidget(
    { name: NAME, category: 'Images', componentId: ID },
    {
      defaults: {
        images: [{
          file: '/img/grid-1.jpg',
          alt: 'Small storage units',
          link: '',
          target: '_self',
          title: '',
        },
        {
          file: '/img/grid-2.jpg',
          alt: 'Large storage units',
          link: '',
          target: '_self',
          title: '',
        },
        {
          file: '/img/grid-3.jpg',
          alt: 'Storage lock',
          link: '',
          target: '_self',
          title: '',
        },
        {
          file: '/img/grid-4.jpg',
          alt: 'Storage building',
          link: '',
          target: '_self',
          title: '',
        }],
      },
    },
  ),
)(ImageGrid);
